import { Component, Input, Inject, ContentChildren, EventEmitter, Output, QueryList, AfterViewInit } from '@angular/core';
import { IErrorHandler } from '../../../shared/dataModels/contracts/IErrorHandler';
import { Configuration } from '../../../shared/configurations/shared.config';
import { FileUploader } from '../../../shared/components/fileUpload/classes/file-uploader.class';
import { LocalizePipe } from '../../../shared/pipes/Localize.pipe';
import { TabItemComponent } from './tab-item.component';

@Component({
    moduleId: module.id,
    selector: 'tabs',
    templateUrl: 'tabs.component.html',
})
export class TabsComponent implements AfterViewInit {

    private _errorHandler: IErrorHandler;

    @ContentChildren(TabItemComponent) tablists: QueryList<TabItemComponent>;
    @Output() onSelected: EventEmitter<any> = new EventEmitter<any>();
    tabs = [];

    constructor( @Inject("IErrorHandler") handler: IErrorHandler, private _localizer: LocalizePipe) {

        this._errorHandler = handler;
    }

    ngAfterViewInit() {
        this.serializedTabs();
        this.tablists.changes.subscribe(x => {
            this.serializedTabs();
        });

        this.selectActive();
    }

    tabClicked(id) {
        this.tablists.forEach(x => x.active = false);
        let it = this.tablists.find(x => x.id == id);
        it.active = true;
        it.onSelected.emit(id);
        this.onSelected.emit(id);
    }

    private serializedTabs() {
        setTimeout(() => this.tabs = this.tablists.map(x => ({ id: x.id, header: x.header, active: x.active })), 0);
    }

    private selectActive() {
        let active = this.tablists.find(x => x.active);
        if (active) {
            active.onSelected.emit(active.id);
            this.onSelected.emit(active.id);
        }
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/tabs/tabs.component.ts